import React from "react";
import Dialog from "@hyro-components/Dialogs/HyroUiDialog";

import { PUBLISH_BUTTON } from "src/pages/admin/GeneralSettingsConsts";
import { DIALOG_VARIANTS } from "@hyro-components/Dialogs/DialogConsts";

const PublishDialog = ({ isOpen, onCancel, onSumbit, title, isLoading }) => (
  <Dialog
    open={isOpen}
    variant={DIALOG_VARIANTS.transactional}
    submitButtonText={PUBLISH_BUTTON.text}
    submitButtonLoading={isLoading}
    title={title}
    handleCancel={onCancel}
    handleSubmit={onSumbit}
  >
    <div>
      You are about to publish changes to production, this will affect the
      assistant within a few minutes.
    </div>
  </Dialog>
);

export default PublishDialog;
